import TagManager from 'react-gtm-module';

export enum CompareGridLocations {
  ProductCompare = 'product compare table',
  FranchiseCompare = 'franchise compare table',
}

export enum CompareGridEventNames {
  ViewCompareTable = 'view_compare_table',
  ScrollCompareTable = 'scroll_compare_table',
  ClickCompareTable = 'click_compare_table',
}

export interface TrackCompareGridEventsProps {
  interactionLocation: string;
  eventName: CompareGridEventNames;
  linkUrl?: string;
  linkText?: string;
  index?: number | null;
  path?: string;
}

export const trackCompareGridEvents = ({
  interactionLocation,
  eventName,
  linkUrl,
  linkText,
  index,
  path,
}: TrackCompareGridEventsProps) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: eventName,
      interaction: {
        interaction_location: interactionLocation,
        ...(linkUrl !== undefined && { link_url: linkUrl }),
        ...(linkText !== undefined && { link_text: linkText }),
        ...(index !== undefined && { index: index?.toString() ?? null }),
        ...(path !== undefined && { event_page: path }),
      },
    },
  });
};
